/**
 * Undo (P2/T13) und Push-Retry (P2/T14) der Review-Queue — eigene Datei, damit
 * `useSuggestionMutations.ts` (apply/discard/retry/start/estimate/preview) die
 * 50-Zeilen-Hook-Grenze nicht reißt (Muster `useRecipeMutations.ts`).
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { retryPushSuggestions, revertSuggestions } from '@/lib/api/channel-content-bulk'

import { textRunKeys } from './runStatus'

export function useUndoRetryMutations() {
  const qc = useQueryClient()
  const invalidateSuggestions = () =>
    qc.invalidateQueries({ queryKey: [...textRunKeys.all, 'suggestions'] })

  return {
    revert: useMutation({
      mutationFn: revertSuggestions,
      onSuccess: () => {
        invalidateSuggestions()
        qc.invalidateQueries({ queryKey: [...textRunKeys.all, 'runs'] })
      },
    }),
    retryPush: useMutation({
      mutationFn: retryPushSuggestions,
      onSuccess: invalidateSuggestions,
    }),
  }
}
